import React from "react";
import Alert from "components/Alert";
import IconHeader from "components/IconHeader";
import IconSubheader from "components/IconSubheader";
import IconCircle from "components/IconCircle";

interface IconBannerProps {
  title?: string;
  subheader?: React.ReactNode;
  actionComponent?: React.ReactNode;
  errorMsg?: string;
  error?: boolean;
  icon?: React.ReactNode;
  circleBackgroundColor?: string;
  iconColor?: string;
  iconSize?: number;
  circle?: boolean;
  color?: string;
}

const IconBanner = ({
  title,
  subheader,
  actionComponent,
  errorMsg,
  error,
  circle = true,
  color,
  icon,
}: IconBannerProps) => {
  return (
    <div className="banner-container">
      <div className="banner-content">
        <div className="banner-info">
          <div className="banner-info-body">
            {circle && (
              <div className="banner-icon-wrapper">
                <IconCircle type={color} icon={icon} />
              </div>
            )}
            <div className="banner-text">
              <IconHeader variant="iconBanner" headerText={title} />
              {subheader && <IconSubheader subheader={subheader} />}
            </div>
          </div>
          {actionComponent && (
            <div className="banner-action">{actionComponent}</div>
          )}
        </div>
      </div>
      {error && <Alert msg={errorMsg as string} type="error" />}
    </div>
  );
};

export default IconBanner;
